<script lang="ts">
  import { resolve } from '$app/paths'
  import { page } from '$app/state'
  import Logo from './images/Logo.svelte'
  import Heading from './ui/Heading.svelte'

  let visible = $derived(!page.url.pathname.startsWith('/session'))
</script>

{#if visible}
  <footer>
    <nav>
      <div class="nav-group">
        <Heading size="sm" tag="h1">Product</Heading>
        <ul>
          <li><a href={resolve('/')}>Home</a></li>
          <li><a href={resolve('/business')}>Business</a></li>
          <li><a href={resolve('/pricing')}>Pricing</a></li>
          <li><a href={resolve('/help')}>Help</a></li>
        </ul>
      </div>
      <div class="nav-group">
        <Heading size="sm" tag="h1">Company</Heading>
        <ul>
          <li><a href={resolve('/contact')}>Contact</a></li>
          <li><a href={resolve('/legal/legal-notice')}>Legal Notice</a></li>
          <li>
            <a href={resolve('/legal/terms-of-service')}>Terms of Service</a>
          </li>
          <li><a href={resolve('/legal/privacy-policy')}>Privacy Policy</a></li>
        </ul>
      </div>
      <div class="company">
        <div class="name"><Logo /></div>
        <p class="copyright">
          Copyright © 2022-{new Date().getFullYear()} Pausly e.U.<br />
          All Rights Reserved
        </p>
      </div>
    </nav>
  </footer>
{/if}

<style lang="postcss">
  footer {
    background: var(--color-bg-dark);
    padding-inline: var(--size-content-medium-px);
    padding-block: 3rem fluid(6rem, 11rem, 480px, 1128px);
    color: var(--color-text-ondark);
  }
  .name {
    margin-bottom: 1.5rem;
    height: 2rem;
    color: var(--color-text-ondark);
    font-weight: var(--weight-bold);
    font: var(--display-md);
    & :global(svg) {
      width: auto;
      height: 100%;
    }
  }
  nav {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
    @media screen and (min-width: 800px) {
      grid-template-columns: 1fr auto auto;
    }
    gap: fluid(3rem, 6rem, 480px, 1128px);
    /* max-width: 786px; */
    & ul {
      margin: 0;
      padding: 0;
      & li {
        display: block;
        margin-bottom: 1rem;
        list-style: none;
        /* text-align: right; */

        & a {
          color: var(--color-text-ondark);
          font-weight: var(--weight-regular);
          &:hover {
            color: var(--color-text-accent-ondark);
          }
        }
      }
    }
  }
  .company {
    /* margin-top: fluid(3rem, 6rem, 480px, 1128px); */
    grid-column: 1 / -1;
    @media screen and (min-width: 800px) {
      grid-row: 1;
      grid-column: auto;
    }
    & .copyright {
      /* margin-top: 3rem; */
      color: var(--color-text-ondark);
      @media screen and (min-width: 800px) {
        margin-top: 0.5rem;
      }
    }
  }
</style>
